import { Text } from '@change/ds-core-ui';

import { VerifiedAvatar } from '../../../../shared/components/VerifiedAvatar';

type EndorsementCardProps = {
	endorsement: {
		author: {
			displayName: string | undefined;
			profilePhotoUrl: string | null | undefined;
		};
		message: string | null;
	};
};

export const EndorsementCard: React.FC<EndorsementCardProps> = ({ endorsement: { message, author } }) => {
	return (
		<div className="bg-fill-accent-primary-weaker rounded-large flex w-[274px] shrink-0 flex-col justify-between pt-6 pr-5 pb-5 pl-6 md:w-auto">
			<Text className="mb-10 font-serif text-sm italic">&ldquo;{message}&rdquo;</Text>
			<div className="flex items-start gap-2.5">
				<VerifiedAvatar avatarUrl={author.profilePhotoUrl || ''} />
				<Text className="mt-0.5 text-sm font-bold">{author.displayName}</Text>
			</div>
		</div>
	);
};
